var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "quotes",
    width: "24px",
    height: "21px",
    viewBox: "0 0 24 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u201C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "quotes-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "quotes-2",
    transform: "translate(-308.000000, -811.000000)",
    fill: "#151515",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "quotes-3",
    transform: "translate(296.000000, 798.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "quotes-4",
    d: "M22,34 L22,23.9252336 L17.3549572,23.9252336 C17.3549572,22.3115265 17.6833945,20.9485981 18.3402693,19.8364486 C18.997144,18.7242991 20.2170543,17.8847352 22,17.317757 L22,13 C20.5454916,13.1744548 19.1965524,13.5778816 17.9531824,14.2102804 C16.7098123,14.8426791 15.6423909,15.6386293 14.750918,16.5981308 C13.8594451,17.5576324 13.1673807,18.6697819 12.6747246,19.9345794 C12.1820685,21.1993769 11.9592003,22.5514019 12.00612,23.9906542 L12.00612,34 L22,34 Z M36,34 L36,23.9252336 L31.3549572,23.9252336 C31.3549572,22.3115265 31.6833945,20.9485981 32.3402693,19.8364486 C32.997144,18.7242991 34.2170543,17.8847352 36,17.317757 L36,13 C34.5454916,13.1744548 33.1965524,13.5778816 31.9531824,14.2102804 C30.7098123,14.8426791 29.6423909,15.6386293 28.750918,16.5981308 C27.8594451,17.5576324 27.1673807,18.6697819 26.6747246,19.9345794 C26.1820685,21.1993769 25.9592003,22.5514019 26.00612,23.9906542 L26.00612,34 L36,34 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.c004260edff689acb8a9c3fcfd45a533.svg";
export { ForwardRef as ReactComponent };